/**
 * Download a file with the given filename and content
 * @param {string} fileName - The name of the file to download
 * @param {string} content - The content of the file
 */
export const downloadFile = (fileName, content) => {
  // Ensure .swift extension for Swift files
  let finalFileName = fileName;
  if (!fileName.endsWith('.swift') && 
      (content.includes('import SwiftUI') || 
       content.includes('import Foundation') ||
       content.includes('struct ') ||
       content.includes('extension '))) {
    // Remove any existing extension and add .swift
    const nameWithoutExt = fileName.replace(/\.[^/.]+$/, '');
    finalFileName = `${nameWithoutExt}.swift`;
  }
  
  // Determine MIME type based on file extension
  const mimeType = finalFileName.endsWith('.swift') 
    ? 'text/x-swift' 
    : 'text/plain';
  
  // Create a Blob with the content and appropriate MIME type
  const blob = new Blob([content], { type: mimeType });
  
  // Create a temporary URL for the blob
  const url = URL.createObjectURL(blob);
  
  // Create a temporary anchor element
  const link = document.createElement('a');
  link.href = url;
  link.download = finalFileName;
  
  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Revoke the object URL to free memory
  URL.revokeObjectURL(url);
};
